import React, { useState, useEffect } from 'react';
import MobilePage from '../UiComponents/MobilePage';
import HeroView from './HeroView';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './Heroes.css';
import { logout, isLogin } from '../Utils/Cookies.js';
import butterflyApi from '../ButterflyApi';

const Heroes = () => {
  const navigate = useNavigate();
  const [heroNo, setHeroNo] = useState(isLogin() ? localStorage.getItem("heroNo") : 1)
  const heroes = JSON.parse(localStorage.getItem("heroes"))
  const [emailAgree, setEmailAgree] = useState(false)


  const onHeroClick = (heroNo) => {
    localStorage.setItem("heroNo", heroNo)
    setHeroNo(heroNo)
  }

  const onLogout = () => {
    logout()
    navigate('/')
  }

  const onLeave = async () => {
    if (!window.confirm('정말 탈퇴하시겠습니까?\n탈퇴하시면 모든 데이터가 삭제되며 복구할 수 없습니다.')) {
      return
    }

    try {
      await butterflyApi.leave()
      alert('탈퇴가 완료되었습니다.')
      logout()
      navigate('/')
    } catch (error) {
      alert('탈퇴 처리 중 오류가 발생했습니다.')
      console.error('탈퇴 오류:', error)
    }
  }

  const onEmailAgreeChange = async (e) => {
    const checked = e.target.checked
    setEmailAgree(checked)
    try {
      await butterflyApi.updateEmailAgree(checked)
    } catch (error) {
      alert('이메일 수신 동의 설정 중 오류가 발생했습니다.')
      console.error('이메일 수신 동의 업데이트 오류:', error)
      setEmailAgree(!checked) // 롤백
    }
  }

  const loadEmailAgree = async () => {
    try {
      const supporter = await butterflyApi.getSupporter()
      if (supporter?.emailAgree !== undefined) {
        setEmailAgree(supporter.emailAgree)
      }
    } catch (error) {
      console.error('이메일 수신 동의 상태 로드 오류:', error)
    }
  }

  useEffect(() => {
    if (!heroes || heroes.length === 0) {
      navigate('/heroes/add')
      return
    }
    loadEmailAgree()
  }, [])

  return <MobilePage className="storybook-page heroes-page" heroNo={heroNo}>
    <main className="heroes-content">
      <header className="heroes-intro">
        <p className="book-eyebrow"><span aria-hidden="true">✦</span> 우리 아이의 이야기 책장</p>
        <h1 className="book-title">오늘의 주인공은 누구일까요?</h1>
        <p className="book-description">이야기 속으로 함께 떠날 아이를 골라주세요.<br />아이만의 특별한 모험이 기다리고 있어요.</p>
      </header>

      <section aria-labelledby="heroes-heading" className="heroes-list">
        <div className="heroes-section-heading">
          <h2 id="heroes-heading">나의 주인공 <span>{heroes?.length || 0}</span></h2>
          <span>카드를 눌러 선택해요</span>
        </div>
        {heroes?.map(hero => <HeroView key={hero.heroNo} hero={hero} onClick={onHeroClick} selected={String(hero.heroNo) === String(heroNo)} />)}
        {!heroes?.length && <p className="heroes-empty">첫 번째 이야기의 주인공을 등록해 주세요.</p>}
        <Link className="heroes-add" to="/heroes/add">
          <span className="heroes-add-icon" aria-hidden="true">＋</span>
          <span><strong>새로운 주인공 추가하기</strong><small>또 한 아이의 상상을 펼쳐주세요</small></span>
          <span className="heroes-arrow" aria-hidden="true">↗</span>
        </Link>
      </section>

      <aside className="heroes-note">
        <span aria-hidden="true">✧</span>
        <p>가족과 친구를 소개해 주면<br />더 친근하고 특별한 동화가 완성돼요.</p>
      </aside>

      <section className="heroes-account" aria-labelledby="account-heading">
        <h2 id="account-heading">계정 설정</h2>
        <label className="heroes-email">
          <span><strong>이메일 수신 동의</strong><small>이메일 수신 여부를 변경할 수 있어요.</small></span>
          <input type="checkbox" checked={emailAgree} onChange={onEmailAgreeChange} />
        </label>
        <div className="heroes-account-actions">
          <button type="button" onClick={onLogout}>로그아웃</button>
          <button type="button" onClick={onLeave}>탈퇴하기</button>
        </div>
      </section>
    </main>
  </MobilePage>
}

export default Heroes
